import Svg, { G, Path, Rect, type SvgProps } from 'react-native-svg';
import { withDefaultIconProps } from './index';
import { LogoHauteGaspesie, LogoMutuoSplash, LogoRefrainCarre, LogoSerresSplash } from 'app/design/branding/logo';
import React from 'react';
import { WhiteLabel } from 'app/types/white-labels';

import { isWhiteLabel } from 'app/utils/helpers';
import { env } from 'app/lib/env';
import { createTheme as createDSTheme, useTheme } from 'app/shopify';
const theme = createDSTheme();

// The notification design uses the inverse wordmark, without the splash asset's outer whitespace.
function MutuoSquareLogo({ height, width, ...rest }: SvgProps) {
  const notificationTheme = useTheme();
  return (
    <Svg {...rest} height={height} viewBox="0 0 64 64" width={width}>
      <Rect
        x={0.5}
        y={0.5}
        width={63}
        height={63}
        rx={notificationTheme.borderRadii['radius.sm']}
        fill={notificationTheme.colors['surface.secondary']}
        stroke={notificationTheme.colors['border.secondary']}
        strokeWidth={1}
      />
      <G transform="translate(4.676 22)">
        <LogoMutuoSplash
          width={54.648}
          height={20}
          viewBox="15 30 546.195 198.021"
          colorText={notificationTheme.colors['text.brand']}
        />
      </G>
    </Svg>
  );
}

export const SquareLogo = withDefaultIconProps(
  {
    height: 60,
    width: 60,
  },
  ({ height, width, ...rest }) =>
    isWhiteLabel(WhiteLabel.Refrain) ? (
      <Svg {...rest} height={height} viewBox="0 0 60 60" width={width}>
        <Rect
          fill={theme.colors['surface.tertiary']}
          height="60"
          rx="16"
          width="60"
          transform={[{ translateY: 0.5 }]}
        />
        <G transform="translate(0 3)">
          <LogoRefrainCarre color={theme.colors['text.brand']} height={60} width={60} />
        </G>
      </Svg>
    ) : isWhiteLabel(WhiteLabel.SerresTessier) ? (
      <Svg {...rest} height={height} viewBox="0 0 60 60" width={width}>
        <Rect
          fill={theme.colors['surface.tertiary']}
          height="60"
          rx="16"
          width="60"
          transform={[{ translateY: 0.5 }]}
        />
        <LogoSerresSplash height={height} width={width} />
      </Svg>
    ) : isWhiteLabel(WhiteLabel.Mutuo) ? (
      <MutuoSquareLogo {...rest} height={height} width={width} />
    ) : isWhiteLabel(WhiteLabel.HauteGaspesie) ? (
      <LogoHauteGaspesie
        {...rest}
        height={height}
        squareBackgroundColor={theme.colors['white-label.theme.surface.accent']}
        width={width}
      />
    ) : env.IS_PARTAKE ? (
      <Svg {...rest} height={height} viewBox="0 0 60 60" width={width}>
        <Rect width="60" height="60" rx="16" fill="#005A5D" />
        <Path
          d="M8.45 24.8H5V36.11H7.42V31.93H8.45C10.9 31.93 12.62 30.59 12.62 28.37C12.62 26.15 10.9 24.8 8.45 24.8V24.8ZM8.41 29.95H7.42V26.78H8.41C9.47 26.78 10.24 27.32 10.24 28.37C10.24 29.42 9.47 29.95 8.41 29.95Z"
          fill="white"
        />
        <Path
          d="M18.22 29.48C17.77 28.9 16.92 28.4 15.88 28.4C13.83 28.4 12.16 30.1 12.16 32.35C12.16 34.6 13.83 36.29 15.88 36.29C16.92 36.29 17.77 35.8 18.22 35.21V36.11H20.5V28.58H18.22V29.48V29.48ZM16.36 34.33C15.25 34.33 14.42 33.47 14.42 32.35C14.42 31.22 15.25 30.37 16.36 30.37C17.47 30.37 18.28 31.22 18.28 32.35C18.28 33.47 17.46 34.33 16.36 34.33Z"
          fill="white"
        />
        <Path
          d="M23.51 29.66V28.58H21.23V36.11H23.51V32.5C23.51 31.37 24.26 30.74 25.33 30.74C25.62 30.74 25.86 30.77 26.13 30.86V28.54C25.96 28.49 25.8 28.45 25.57 28.45C24.64 28.45 23.89 29 23.51 29.66L23.51 29.66Z"
          fill="white"
        />
        <Path d="M29.09 26.13H26.81V36.11H29.09V30.92H30.98V28.58H29.09V26.13Z" fill="white" />
        <Path
          d="M37.42 29.48C36.97 28.9 36.11 28.4 35.08 28.4C33.02 28.4 31.35 30.1 31.35 32.35C31.35 34.6 33.02 36.29 35.08 36.29C36.11 36.29 36.97 35.8 37.42 35.21V36.11H39.7V28.58H37.42V29.48V29.48ZM35.56 34.33C34.44 34.33 33.62 33.47 33.62 32.35C33.62 31.22 34.44 30.37 35.56 30.37C36.67 30.37 37.48 31.22 37.48 32.35C37.48 33.47 36.65 34.33 35.56 34.33Z"
          fill="white"
        />
        <Path
          d="M51.22 28.4C49.15 28.4 47.34 30.07 47.34 32.35C47.34 34.63 49.15 36.29 51.28 36.29C52.74 36.29 53.98 35.63 54.7 34.45L53.1 33.34C52.66 34.01 52.17 34.43 51.28 34.43C50.4 34.43 49.68 33.89 49.45 32.96H54.99C55.14 30.35 53.68 28.4 51.22 28.4ZM49.53 31.54C49.8 30.73 50.47 30.25 51.24 30.25C52.21 30.25 52.72 30.89 52.83 31.54H49.53Z"
          fill="white"
        />
        <Path
          d="M48.17 28.57H45.48L42.71 31.75V24H40.43V36.11H42.71V32.51L45.58 36.11H48.24L45.03 32.05L48.17 28.57Z"
          fill="white"
        />
      </Svg>
    ) : (
      <Svg {...rest} height={height} viewBox="0 0 60 60" width={width}>
        <Rect width="60" height="60" rx="16" fill="#B8ECE0" />
        <Path
          d="M7.32 29.75H5V19H8.32C10.67 19 12.33 20.27 12.33 22.39C12.33 24.52 10.67 25.77 8.32 25.77H7.32V29.75ZM7.32 23.89H8.28C9.3 23.89 10.04 23.39 10.04 22.39C10.04 21.4 9.3 20.88 8.28 20.88H7.32V23.89Z"
          fill="black"
        />
        <Path
          d="M19.91 22.59V29.75H17.71V28.9C17.28 29.45 16.46 29.93 15.46 29.93C13.48 29.93 11.88 28.31 11.88 26.17C11.88 24.04 13.48 22.42 15.46 22.42C16.46 22.42 17.28 22.89 17.71 23.45V22.59H19.91ZM15.92 28.06C16.98 28.06 17.77 27.24 17.77 26.17C17.77 25.11 16.98 24.29 15.92 24.29C14.87 24.29 14.06 25.11 14.06 26.17C14.06 27.24 14.86 28.06 15.92 28.06Z"
          fill="black"
        />
        <Path
          d="M25.31 24.76C25.05 24.68 24.82 24.65 24.55 24.65C23.52 24.65 22.8 25.25 22.8 26.32V29.75H20.61V22.59H22.8V23.62C23.16 22.99 23.88 22.46 24.78 22.46C24.99 22.46 25.15 22.51 25.31 22.55V24.76Z"
          fill="black"
        />
        <Path d="M25.96 20.27H28.16V22.59H29.98V24.82H28.16V29.75H25.96V20.27Z" fill="black" />
        <Path
          d="M38.36 22.59V29.75H36.17V28.9C35.73 29.45 34.91 29.93 33.92 29.93C31.94 29.93 30.34 28.31 30.34 26.17C30.34 24.04 31.94 22.42 33.92 22.42C34.91 22.42 35.73 22.89 36.17 23.45V22.59H38.36ZM34.38 28.06C35.43 28.06 36.22 27.24 36.22 26.17C36.22 25.11 35.43 24.29 34.38 24.29C33.32 24.29 32.52 25.11 32.52 26.17C32.52 27.24 33.31 28.06 34.38 28.06Z"
          fill="black"
        />
        <Path
          d="M42.99 33.49C40.96 33.49 39.24 32.28 39.15 30.32H41.32C41.4 31.2 42.08 31.72 43.02 31.72C44.04 31.72 44.82 31.07 44.82 29.81V28.9C44.39 29.45 43.57 29.93 42.57 29.93C40.6 29.93 38.99 28.31 38.99 26.17C38.99 24.04 40.6 22.42 42.57 22.42C43.57 22.42 44.39 22.89 44.82 23.45V22.59H47.02V29.73C47.02 32.05 45.13 33.49 42.99 33.49ZM43.03 28.06C44.09 28.06 44.88 27.24 44.88 26.17C44.88 25.11 44.09 24.29 43.03 24.29C41.98 24.29 41.17 25.11 41.17 26.17C41.17 27.24 41.97 28.06 43.03 28.06Z"
          fill="black"
        />
        <Path
          d="M53.19 27.12L54.74 28.17C54.04 29.3 52.85 29.93 51.45 29.93C49.4 29.93 47.65 28.33 47.65 26.17C47.65 24.02 49.4 22.42 51.39 22.42C53.76 22.42 55.16 24.28 55.01 26.76H49.69C49.9 27.64 50.61 28.16 51.45 28.16C52.28 28.16 52.77 27.76 53.19 27.12ZM49.76 25.4H52.93C52.83 24.79 52.34 24.18 51.4 24.18C50.67 24.18 50.02 24.63 49.76 25.4Z"
          fill="black"
        />
        <Path
          d="M22.67 39.83C23.73 39.83 24.64 39.41 25.25 38.83V41.4C24.47 41.79 23.56 41.99 22.62 41.99C19.48 41.99 16.94 39.5 16.94 36.45C16.94 33.39 19.48 30.9 22.62 30.9C23.56 30.9 24.47 31.11 25.25 31.5V34.06C24.64 33.48 23.73 33.07 22.67 33.07C20.72 33.07 19.26 34.52 19.26 36.45C19.26 38.37 20.72 39.83 22.67 39.83Z"
          fill="black"
        />
        <Path d="M28.16 30.33V41.83H25.97V30.33H28.16Z" fill="black" />
        <Path
          d="M33.35 38.81V34.67H35.55V38.88C35.55 40.72 34.13 42 32.19 42C30.24 42 28.81 40.72 28.81 38.86V34.67H31V38.81C31 39.65 31.43 40.15 32.19 40.15C32.94 40.15 33.35 39.65 33.35 38.81Z"
          fill="black"
        />
        <Path
          d="M38.36 35.52C38.78 34.97 39.6 34.49 40.6 34.49C42.57 34.49 44.17 36.11 44.17 38.25C44.17 40.38 42.57 42 40.6 42C39.6 42 38.78 41.53 38.36 40.97V41.83H36.17V30.33H38.36V35.52ZM40.15 36.36C39.08 36.36 38.29 37.18 38.29 38.25C38.29 39.32 39.08 40.13 40.15 40.13C41.22 40.13 42 39.32 42 38.25C42 37.18 41.2 36.36 40.15 36.36Z"
          fill="black"
        />
      </Svg>
    ),
);
